import moment from "moment";

import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { IPatientEnrollmentModel } from "@/Common/Models/Patient/UI/Profile/IPatientEnrollmentModel";
import { RAMQInscription } from "@/Common/Models/RAMQ/RAMQInscription";
import { IPatientProfileEnrollmentComponentProps } from "./IPatientProfileComponentProps";

class PatientProfileEnrollmentClientComponent extends React.Component<IPatientProfileEnrollmentComponentProps, any> {
    public render(): JSX.Element {
        var enrolmentModel = this.props.model;
        var ramqInfo: RAMQInscription;

        if (enrolmentModel) {
            ramqInfo = enrolmentModel.get("RAMQInscription");
        }

        return this.GetClientRender(ramqInfo, enrolmentModel, this.props.IsInAddMode || this.props.IsInEditMode);
    }

    private GetClientRender(ramqInfo: RAMQInscription, model: IPatientEnrollmentModel, showAddEdit: boolean): JSX.Element {
        var clientRender: JSX.Element = null;

        if (showAddEdit) {
            clientRender = null;
        }
        else if (ramqInfo) {
            clientRender = (
                <tbody>
                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("FirstNameLabel")}</span>
                        </td>
                        <td className="c2">
                            <strong>{MyleHelper.ReplaceEmptyString(ramqInfo.PatientFirstName)}</strong>
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("LastNameLabel")}</span>
                        </td>
                        <td className="c2">
                            <strong>{MyleHelper.ReplaceEmptyString(ramqInfo.PatientLastName)}</strong>
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("SexAtBirthLabel")}</span>
                        </td>
                        <td className="c2">
                            <strong>{MyleHelper.ReplaceEmptyString(ramqInfo.PatientSexe)}</strong>
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("DateofBirthLabel")}</span>
                        </td>
                        <td className="c2">
                            <strong>{MyleHelper.ReplaceEmptyString(moment(ramqInfo.PatientDDN).format("YYYY-MM-DD hh:mm:ss"))}</strong>
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{sessionStore.getDefaultHealthCardLabel()}</span>
                        </td>
                        <td className="c2">
                            <strong>{MyleHelper.ReplaceEmptyString(ramqInfo.PatientNAM)}</strong>
                        </td>
                    </tr>

                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("PreferredOfficialLanguageLabel")}</span>
                        </td>
                        <td className="c2">
                            <strong>{MyleHelper.ReplaceEmptyString(ramqInfo.PatientLangue)}</strong>
                        </td>
                    </tr>
                </tbody>
            );
        }
        else {
            clientRender = (<div />);
        }

        return clientRender;
    }
}

export { PatientProfileEnrollmentClientComponent };
